import { Box } from '@mui/material';
import React from 'react';

// A single shimmering block. Uses the global `.skeleton` gradient from
// index.scss so every skeleton in the app animates in step.
const Shimmer = ({ width = '100%', height = 14, radius = 6, sx = {} }) => (
  <Box
    className="skeleton"
    sx={{ width, height, borderRadius: `${radius}px`, flexShrink: 0, ...sx }}
  />
);

export default Shimmer;
